import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TrackReviewActivityDirective } from '../../../directives/track-review-activity.directive';

// the shared incident report grid carries the review outcome comments as `comments`,
// the report builder grid carries the same text as `summary`
type ReportActionsRow = {
  review_id?: string;
  comments?: string;
  summary?: string;
};

type CellParams = ICellRendererParams<ReportActionsRow>;

@Component({
  selector: 'app-pan-cell-theft-report-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, TrackReviewActivityDirective],
  templateUrl: './cell-theft-report-actions.component.html',
  styleUrl: './cell-theft-report-actions.component.scss',
})
export class CellTheftReportActionsComponent implements ICellRendererAngularComp {
  public reviewId = '';
  public comments = '';

  agInit(params: CellParams) {
    this.setRow(params);
  }

  refresh(params: CellParams) {
    this.setRow(params);
    return true;
  }

  private setRow(params: CellParams) {
    this.reviewId = params.data?.review_id ?? '';
    this.comments = params.data?.comments ?? params.data?.summary ?? '';
  }
}
